module.exports = __webpack_public_path__ + "static/media/hinted-Whitney-Book.c60cd3fb.ttf";